import React, { useCallback, useState } from 'react';
import { EVENT_STATUS, MARKET_STATUS, SPORTS } from 'constants/appConfig';
import {
    EventNamesVinderspil,
    EventNameVinderspil,
    EventVinderspilMarketItem,
    SmallInfoTextVinderspil,
    ViewEventListVinderspilBox,
} from './styled';
import { Col, Row } from '../../styled';
import Text from '../../ui/Text';
import ViewVinderspilMarkets from '../ViewVinderspilMarketsNew';
import { detectMobile } from '../../utils/UiHelper';

const VindespilEventListItem = ({ ev, marketList }) => {
    const [opened, setOpened] = useState(false);
    const isMobile = detectMobile();
    const limit = isMobile ? 6 : 8;

    const setScrollPosition = (id) => {
        setTimeout(() => {
            let rect = document
                .querySelector('#market-id-' + id)
                ?.getBoundingClientRect();
            let elOffset = rect?.top + window.scrollY;
            let differences = isMobile ? 145 : 125;
            const isNeedScroll = elOffset < differences + window.scrollY;

            if (elOffset && differences && isNeedScroll) {
                window.scrollTo({
                    top: elOffset - differences,
                    behavior: 'smooth',
                });
            }
        }, 100);
    };

    const toggleViderspil = (marketId) => {
        if (opened) {
            setScrollPosition(marketId);
        }

        setOpened((prevOpened) => !prevOpened);
    };

    const renderMarketItem = (ev, marketList, item, index) => {
        const isDisabled =
            marketList.status !== MARKET_STATUS.ACTIVE ||
            ev.status !== EVENT_STATUS.IN_PROGRESS;

        return (
            <EventVinderspilMarketItem
                key={`vinderspil-item_${item.id}_${index}`}
                $isMobile={isMobile}
            >
                <ViewVinderspilMarkets
                    disabled={isDisabled}
                    market={marketList}
                    ev={ev}
                    item={item}
                    live={ev.live ? '1' : '0'}
                />
            </EventVinderspilMarketItem>
        );
    };

    const getVinderspilView = (ev, marketList, itemList) => {
        if (!marketList) {
            return null;
        }

        let itemsToRender = itemList;

        if (!opened) {
            itemsToRender = itemList.slice(0, limit);
        }

        return itemsToRender.map((item, index) =>
            renderMarketItem(ev, marketList, item, index)
        );
    };

    return marketList.map((market, index) => {
        const itemList = market?.itemList
            ? market?.itemList.filter((item) => item.odds > 1)
            : [];

        return (
            <ViewEventListVinderspilBox
                key={market.marketId}
                id={`market-id-${market.marketId}`}
            >
                <Row>
                    <Col>
                        <EventNamesVinderspil>
                            <EventNameVinderspil>
                                {ev?.sportId === SPORTS.HESTESPORT
                                    ? ev?.marketList[index].marketName
                                    : ev?.eventName}
                            </EventNameVinderspil>
                        </EventNamesVinderspil>
                        {market?.freeText ? (
                            <SmallInfoTextVinderspil>
                                <i>({market?.freeText})</i>
                            </SmallInfoTextVinderspil>
                        ) : null}
                    </Col>
                </Row>
                <Row $wrap={'wrap'} $gap={'8px'}>
                    {getVinderspilView(ev, market, itemList)}
                    {itemList && itemList.length > limit ? (
                        <Text
                            align="center"
                            size="13"
                            lh="20"
                            margin="0"
                            padding="8px"
                            color="#186BF5"
                            width="100%"
                            cursor="pointer"
                            onClick={() => toggleViderspil(market.marketId)}
                        >
                            {!opened
                                ? `Se alle ${itemList.length} deltagere`
                                : 'Se færre deltagere'}
                        </Text>
                    ) : null}
                </Row>
            </ViewEventListVinderspilBox>
        );
    });
};

export default VindespilEventListItem;
